import { Grid, Box, Typography } from '@mui/material'
import Block from '@mui/icons-material/Block'
import { VoidCompReasonModel, VoidCompReasonType } from 'models'
import React from 'react'
interface props {
    void: VoidCompReasonModel | undefined
}
export function CartVoid({ void: model }: props) {
    if (!model || model.type === VoidCompReasonType.Comp) return null

    return (
        <Grid item container>
            <Grid item>
                <Block></Block>
            </Grid>
            <Grid item>
                <Box ml={1}>
                    <Typography>Void</Typography>
                    <Typography style={{ fontSize: 12 }}>
                        {model.name || ''}
                    </Typography>
                </Box>
            </Grid>
        </Grid>
    )
}
